// useTableColumnsReingresoSerie.tsx

import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { ReingresoSerie } from "../types";
import { calcColorCalculatorMaterialUI, emptyCellObject, formatDateWithTime } from "@/shared";
import { Chip, IconButton, Tooltip } from "@mui/material";
import { ManageSearch } from "@mui/icons-material";
import { useModalInformacionReingresoSerieStore } from "../components/modal-informacion-reingreso-serie/useModalInformacionReingresoSerie.store";
import { ReingresoSerieChoice } from "../utils/reingreso-serie.choice";

type UseTableColumnsReingresoSerieProps = {
  estado: ReingresoSerieChoice
}

export function useTableColumnsReingresoSerie({ estado }: UseTableColumnsReingresoSerieProps) {

  const setOpen = useModalInformacionReingresoSerieStore(s => s.setOpen)
  const setSerie = useModalInformacionReingresoSerieStore(s => s.setSerie)


  const columns = useMemo<MRT_ColumnDef<ReingresoSerie>[]>(
    () => [
      {
        id: 'actions',
        header: 'Accion',
        size: 25,
        Cell: (row) => (
          <Tooltip title="Ver detalle">
            <IconButton onClick={() => {
              setOpen(true)
              setSerie(row.row.original.serie.serie)
            }}>
              <ManageSearch color="primary" />
            </IconButton>
          </Tooltip>
        )
      },
      {
        id: 'serie__serie',
        accessorKey: "serie__serie",
        header: "Serie",
        Cell: ({ row }) => emptyCellObject(row.original.serie, 'serie')
      },
      {
        id: 'nombre_producto',
        accessorKey: "Producto",
        header: "Producto",
        Cell: ({ row }) => emptyCellObject(row.original, 'nombre_producto')
      },
      {
        id: 'estado',
        accessorKey: "estado",
        header: "Estado",
        Cell: ({ row }) => <Chip
          sx={{ width: '100%' }}
          color={calcColorCalculatorMaterialUI(row.original.estado) as any}
          label={row.original.estado} />
      },
      {
        id: 'motivo',
        accessorKey: "motivo_emisor",
        header: "Motivo Inventario",
        Cell: ({ row }) => emptyCellObject(row.original, 'motivo_emisor')
      },
      {
        id: 'observacion',
        accessorKey: "observacion_emisor",
        header: "Observación Inventario",
        Cell: ({ row }) => emptyCellObject(row.original, 'observacion_emisor')
      },
      {
        id: 'nombre_bodega',
        accessorKey: "nombre_bodega",
        header: "Bodega",
        Cell: ({ row }) => emptyCellObject(row.original, 'nombre_bodega')
      },
      {
        id: 'nombre_ubicacion',
        accessorKey: "nombre_ubicacion",
        header: "Ubicación",
        Cell: ({ row }) => emptyCellObject(row.original, 'nombre_ubicacion')
      },

      ...([ReingresoSerieChoice.APROBADO, ReingresoSerieChoice.RECHAZADO].includes(estado) ? [
        {
          id: 'motivo_receptor',
          accessorKey: "motivo_receptor",
          header: "Motivo Contabilidad",
          Cell: ({ row }: any) => emptyCellObject(row.original, 'motivo_receptor')
        },
        {
          id: 'observacion_receptor',
          accessorKey: "observacion_receptor",
          header: "Observación Contabilidad",
          Cell: ({ row }: any) => emptyCellObject(row.original, 'observacion_receptor')
        }
      ] : []),
      {
        id: 'fecha_creacion',
        accessorKey: "fecha_creacion",
        header: "Fecha de creación",
        Cell: ({ row }) => `${formatDateWithTime(row.original.fecha_creacion)}`
      },
      {
        id: 'fecha_modificacion',
        accessorKey: "fecha_modificacion",
        header: "Fecha de modificación",
        Cell: ({ row }) => `${formatDateWithTime(row.original.fecha_modificacion)}`
      },
    ],
    []
  );

  return {
    columns
  };
}
